import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnChanges {

  @Input() codes: string[] = [];

  constructor() {}

  ngOnChanges() : void {
    setTimeout(() => {
      if (this.codes!=undefined && this.codes.length>0) {
        this.onAlertClose();
      }
    }, 5000);
  }

  onAlertClose(index: number = undefined) {
    if (index!=undefined) {
      this.codes.splice(index, 1);
    } else {
      this.codes.length = 0;
    }
  }
}
